import type { LanguageType } from '@ingestro/importer-react'
import { localeLanguagePart } from 'config/locales'

const ALLOWED_LANGUAGES: LanguageType[] = [
  'de',
  'en',
  'es',
  'fr',
  'it',
  'nl',
  'pl',
  'pt',
  'sv',
  'cz',
  'dk',
  'hu',
  'lt',
  'no',
  'ru',
  'sk',
  'zh',
]

const isAllowedLanguage = (lang: string): lang is LanguageType => {
  return ALLOWED_LANGUAGES.some((language) => language === lang)
}

interface UseLanguageProps {
  locale?: string
}

export const useLanguage = ({ locale = 'en-US' }: UseLanguageProps) => {
  const languageFromLocale = localeLanguagePart(locale)
  const language = isAllowedLanguage(languageFromLocale) ? languageFromLocale : 'en'

  return {
    language,
  }
}
